import styled from 'styled-components'

export default styled.div`
  background-color: ${ props => props.theme.color.bgLighter };
  box-shadow: 0 17px 15px 0 rgba(0,0,0,0.04);
  border-radius: ${ props => props.theme.value.borderRadius };
  padding: ${ props => props.theme.spacing.ms } ${ props => props.theme.spacing.m };
  transition: all 150ms;
`
